import './Vista3dView.scss'

import React, { Component } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { TABLE_ESTADO_ELEVADOR } from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import Silos3d from '../containers/Silos3d'

class Vista3dView extends Component {
  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <Silos3d />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MuiTable id={TABLE_ESTADO_ELEVADOR} />
          </Col>
        </Row>
      </Container>
    )
  }
}
export default Vista3dView
